<form autocomplete="noAutocomplete" [formGroup]="form">
  <h3 class="fonts-col__heading-3 m-0 mb-20">
    Data Purpose<span> (1/{{ getNumberOfSteps() }})</span>
  </h3>
  <ey-radio-group class="data-purpose" [horizontal]="true" [meta]="meta.dataPurpose" [values]="values" formControlName="dataPurpose"></ey-radio-group>
</form>
